"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var registration_1 = require("../../common/registration");
var useDragDropManager_1 = require("./useDragDropManager");
var TargetConnector_1 = require("../../common/TargetConnector");
var DropTargetMonitorImpl_1 = require("../../common/DropTargetMonitorImpl");
var useIsomorphicLayoutEffect_1 = require("./useIsomorphicLayoutEffect");
function useDropTargetMonitor() {
    var manager = useDragDropManager_1.useDragDropManager();
    var monitor = react_1.useMemo(function () { return new DropTargetMonitorImpl_1.DropTargetMonitorImpl(manager); }, [manager]);
    var connector = react_1.useMemo(function () { return new TargetConnector_1.TargetConnector(manager.getBackend()); }, [
        manager,
    ]);
    return [monitor, connector];
}
exports.useDropTargetMonitor = useDropTargetMonitor;
function useDropHandler(spec, monitor, connector) {
    var manager = useDragDropManager_1.useDragDropManager();
    var handler = react_1.useMemo(function () {
        return {
            canDrop: function () {
                var canDrop = spec.current.canDrop;
                return canDrop ? canDrop(monitor.getItem(), monitor) : true;
            },
            hover: function () {
                var hover = spec.current.hover;
                if (hover) {
                    hover(monitor.getItem(), monitor);
                }
            },
            drop: function () {
                var drop = spec.current.drop;
                if (drop) {
                    return drop(monitor.getItem(), monitor);
                }
            },
        };
    }, [monitor]);
    useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect(function registerHandler() {
        var _a = registration_1.registerTarget(spec.current.accept, handler, manager), handlerId = _a[0], unregister = _a[1];
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [monitor, connector]);
}
exports.useDropHandler = useDropHandler;
